import { MessageAccessType } from 'app-constants/enums/message';
import moment from 'moment';
import { ICON_VARIANT_TYPE, Icons } from 'pages/FormProcess/Icons';

export const getCommentDate = (createdDate) => {
  const isToday = moment(createdDate).format('MM/DD/YYYY') === moment().format('MM/DD/YYYY');
  const isYesterday =
    moment(createdDate).format('MM/DD/YYYY') === moment().subtract(1, 'day').format('MM/DD/YYYY');

  if (isToday) {
    return `Today at ${moment(createdDate).format('hh:mm A')}`;
  } else if (isYesterday) {
    return `Yesterday, ${moment(createdDate).format('hh:mm A')}`;
  } else {
    return moment(createdDate).format('MM/DD/YYYY [at] hh:mm A');
  }
};

export const getCommentIcon = (accessType) => {
  const icons = {
    [MessageAccessType.Everybody]: <Icons variant={ICON_VARIANT_TYPE.Everybody} color="#04a451" />,
    [MessageAccessType.Internal]: <Icons variant={ICON_VARIANT_TYPE.Internal} color="#04a451" />,
    [MessageAccessType.Me]: <Icons variant={ICON_VARIANT_TYPE.Me} color="#04a451" />,
  };

  return icons[accessType];
};
